module.exports = __webpack_public_path__ + "assets/img/m111.d00fbbcc.png";